import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import UPDATE_PLAN_BY_PRICE from './../../../../graphql/UpdatePlanByPrice.graphql'
import { translate } from 'react-i18next'

class PriceModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newPriceComments: ''
    }
    this.onChange = this.onChange.bind(this)
    this.onCommentChange = this.onCommentChange.bind(this)
  }

  updateOrderByPrice() {
    const { updateCustomizedPlan, modalClose, order } = this.props
    updateCustomizedPlan({
      variables: {
        id: this.props.order.id,
        orderStatus: 'ChangePrice',
        additionalCharges: parseInt(this.state.additionalCharges),
        newTotalAmount: order.totalAmount + parseInt(this.state.additionalCharges),
        newPriceComments: this.state.newPriceComments
      }
    }).then(() => modalClose())
  }

  onChange(event) {
    let name = event.target.name
    let value = ''

    if (event.target.value.length < 2 && event.target.value.indexOf('$') !== -1) {
      value = ''
    } else value = event.target.value.slice(-(event.target.value.length - 1))

    this.setState({
      [name]: value
    })
  }

  onCommentChange(event) {
    let name = event.target.name
    this.setState({
      [name]: event.target.value
    })
  }

  render() {
    const { modalClose, order, t } = this.props
    return (
      <div>
        <i className="modal-close" onClick={modalClose} />
        <div className="modal-body">
          <p>
            {t('about_to_change_price')} {t('add_comments')}
            {t('client_required')}
          </p>
          <div className="items">
            <div className="row">
              <div className="column-7">{t('total_price_before')}</div>
              <div className="column-5">
                <input type="text" className="modal-input" value={'$' + order.totalAmount} />
              </div>
            </div>
            <div className="row">
              <div className="column-7">{t('additional_charges')}</div>
              <div className="column-5">
                <input
                  type="text"
                  className="modal-input no-spin"
                  name="additionalCharges"
                  value={this.state.additionalCharges ? '$' + this.state.additionalCharges : ''}
                  onChange={this.onChange}
                />
              </div>
            </div>
            <div className="row">
              <div className="column-7">{t('new_total_price')}</div>
              <div className="column-5">
                <input
                  type="text"
                  className="modal-input"
                  value={
                    this.state.additionalCharges
                      ? '$' + (order.totalAmount + parseInt(this.state.additionalCharges))
                      : '$' + order.totalAmount
                  }
                />
              </div>
            </div>
          </div>

          <div className="textarea-wrapper">
            <div className="symbols">{this.state.newPriceComments.length} / 400</div>
            <textarea name="newPriceComments" maxLength="400" onChange={this.onCommentChange} value={this.state.newPriceComments} />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn order-action" onClick={() => this.updateOrderByPrice()}>
            {t('approve')}
          </button>
        </div>
      </div>
    )
  }
}

const enhance = compose(
  translate('orders'),
  graphql(UPDATE_PLAN_BY_PRICE, {
    name: 'updateCustomizedPlan'
  })
)
export default enhance(PriceModal)



// WEBPACK FOOTER //
// src/components/Guru/Orders/Modals/PriceModal.jsx